export const loaderSx = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  darkBg: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 51,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
};
